import { render, staticRenderFns } from "./DonutChart83.vue?vue&type=template&id=769a11de&scoped=true&"
import script from "./DonutChart83.vue?vue&type=script&lang=js&"
export * from "./DonutChart83.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769a11de",
  null
  
)

export default component.exports